// extracted by mini-css-extract-plugin
export var mainBtn = "screen1-module--main-btn--51231";
export var screen1 = "screen1-module--screen1--33b25";
export var screen1__btn = "screen1-module--screen1__btn--4dc87";
export var screen1__date = "screen1-module--screen1__date--0b045";
export var screen1__desc = "screen1-module--screen1__desc--b4643";
export var screen1__imageWrapper = "screen1-module--screen1__image-wrapper--f6344";
export var screen1__imgContainer = "screen1-module--screen1__img-container--430cb";
export var screen1__imgit = "screen1-module--screen1__imgit--d7dc5";
export var screen1__info = "screen1-module--screen1__info--f603b";
export var screen1__infoCol = "screen1-module--screen1__info-col--e2227";
export var screen1__infoWrapper = "screen1-module--screen1__info-wrapper--69303";
export var screen1__prices = "screen1-module--screen1__prices--8caa6";
export var screen1__pricesNew = "screen1-module--screen1__prices--new--d4b35";
export var screen1__pricesOld = "screen1-module--screen1__prices--old--95992";
export var screen1__pricesProfit = "screen1-module--screen1__prices--profit--d65aa";
export var screen1__text = "screen1-module--screen1__text--d26c8";
export var screen1__title = "screen1-module--screen1__title--987f9";
export var screen1__wrapper = "screen1-module--screen1__wrapper--c7a4d";
export var video__content = "screen1-module--video__content--75717";
export var video__content_wrapper = "screen1-module--video__content_wrapper--226a6";
export var video__text = "screen1-module--video__text--3b576";